import { ISetupService } from "../../core/impl/setupServiceImpl";

export type ISetupController = ReturnType<typeof SetupControllerFactory>;

/**
 * Thin facade for the field-setup wizard. Wraps the service one-to-one so
 * UI never depends on the service directly.
 */
export const SetupControllerFactory = ({
  setupService,
}: {
  setupService: ISetupService;
}) => {
  const fetchAdminClinics: ISetupService["fetchAdminClinics"] = (...args) =>
    setupService.fetchAdminClinics(...args);

  const createPatientAccount: ISetupService["createPatientAccount"] = (
    ...args
  ) => setupService.createPatientAccount(...args);

  const createPatientAccountV2: ISetupService["createPatientAccountV2"] = (
    ...args
  ) => setupService.createPatientAccountV2(...args);

  const replacePatientAccount: ISetupService["replacePatientAccount"] = (
    ...args
  ) => setupService.replacePatientAccount(...args);

  const inviteFamilyMember: ISetupService["inviteFamilyMember"] = (...args) =>
    setupService.inviteFamilyMember(...args);

  const listFamilyMembers: ISetupService["listFamilyMembers"] = (...args) =>
    setupService.listFamilyMembers(...args);

  const assignDeviceToClinicPatient: ISetupService["assignDeviceToClinicPatient"] =
    (...args) => setupService.assignDeviceToClinicPatient(...args);

  return {
    fetchAdminClinics,
    createPatientAccount,
    createPatientAccountV2,
    replacePatientAccount,
    inviteFamilyMember,
    listFamilyMembers,
    assignDeviceToClinicPatient,
  };
};
